if (typeof ProductQuantity !== 'function') {
	class ProductQuantity extends HTMLElement {
			constructor() {
					super();
					this.init();
			}

			init() {
					// Get elements with null checks
					const qty = this.querySelector('.qty-selector');
					const qtyMinus = this.querySelector('.qty-minus');
					const qtyPlus = this.querySelector('.qty-plus');

					// Exit if required elements don't exist
					if (!qty) {
							console.warn('Quantity selector not found');
							return;
					}

					// Get min/max with fallbacks and null checks
					const qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1;
					const qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

					// Initial state setup
					this.updateButtonStates(qty, qtyMinus, qtyPlus, qtyMin, qtyMax);

					// Event Listeners
					if (qty) {
							qty.addEventListener('change', (e) => {
									this.updateButtonStates(qty, qtyMinus, qtyPlus, qtyMin, qtyMax);
							});
					}

					if (qtyMinus) {
							qtyMinus.addEventListener('click', (e) => {
									e.preventDefault();
									this.handleMinusClick(qty, qtyMinus, qtyPlus, qtyMin, qtyMax);
							});
					}

					if (qtyPlus) {
							qtyPlus.addEventListener('click', (e) => {
									e.preventDefault();
									this.handlePlusClick(qty, qtyMinus, qtyPlus, qtyMin, qtyMax);
							});
					}
			}

			updateButtonStates(qty, qtyMinus, qtyPlus, qtyMin, qtyMax) {
					if (!qty) return;

					const currentQty = parseInt(qty.value) || qtyMin;

					if (qtyMinus) {
							qtyMinus.classList.toggle('disabled', currentQty <= qtyMin);
					}

					if (qtyPlus) {
							qtyPlus.classList.toggle('disabled', currentQty >= qtyMax);
					}
			}

			handleMinusClick(qty, qtyMinus, qtyPlus, qtyMin, qtyMax) {
					if (!qty || !qtyMinus || qtyMinus.classList.contains('disabled')) return;

					const currentQty = parseInt(qty.value) || qtyMin;
					if (currentQty - 1 >= qtyMin) {
							qty.value = currentQty - 1;
							this.updateButtonStates(qty, qtyMinus, qtyPlus, qtyMin, qtyMax);
							
							// Dispatch change event
							qty.dispatchEvent(new Event('change', { bubbles: true }));
					}
			}

			handlePlusClick(qty, qtyMinus, qtyPlus, qtyMin, qtyMax) {
					if (!qty || !qtyPlus || qtyPlus.classList.contains('disabled')) return;

					const currentQty = parseInt(qty.value) || qtyMin;
					if (currentQty + 1 <= qtyMax) {
							qty.value = currentQty + 1;
							this.updateButtonStates(qty, qtyMinus, qtyPlus, qtyMin, qtyMax);
							
							// Dispatch change event
							qty.dispatchEvent(new Event('change', { bubbles: true }));
					}
			}
	}

	if (typeof customElements.get('product-quantity') == 'undefined') {
			customElements.define('product-quantity', ProductQuantity);
	}
}